import { render, staticRenderFns } from "./MultipleAnswerStats.vue?vue&type=template&id=2c6fdfae&scoped=true&"
import script from "./MultipleAnswerStats.vue?vue&type=script&lang=ts&"
export * from "./MultipleAnswerStats.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleAnswerStats.vue?vue&type=style&index=0&id=2c6fdfae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6fdfae",
  null
  
)

export default component.exports